import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

import { observable, runInAction, makeObservable, computed } from "mobx";
import * as yup from "yup";
import { persist } from "mobx-persist";

var _SCHEMA = yup.object({
  emailId: yup.string().when("isEmailVisible", {
    is: true,
    then: yup.string().required("Please enter email").email("Please enter valid email")
  })
});

var EmailReceiptModel = (_class = /*#__PURE__*/function () {
  function EmailReceiptModel(platformUtil) {
    _classCallCheck(this, EmailReceiptModel);

    _initializerDefineProperty(this, "_emailId", _descriptor, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor2, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor3, this);

    _initializerDefineProperty(this, "_isEmailVisible", _descriptor4, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    makeObservable(this);
    this._isEmailVisible = true;
  }

  _createClass(EmailReceiptModel, [{
    key: "setUserData",
    value: function setUserData(val) {
      var _this = this;

      runInAction(function () {
        _this._emailId = val;
        _this._isEmailVisible = false;
      });
    }
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this2 = this;

      appMessages.showError("Missing Details.", "Please enter the email address field", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this2.platformUtil.scrollToElement(_this2.componentRef);
        }
      });
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for email details missing for receipt",
        modalContent: "Error modal for email details missing for receipt",
        modalName: "EmailReceipt-Error-Modal"
      });
    }
  }, {
    key: "emailId",
    get: function get() {
      return this._emailId;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._emailId = val;
      });
    }
  }, {
    key: "isEmailVisible",
    get: function get() {
      return this._isEmailVisible;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._isEmailVisible = val;
      });
    }
  }, {
    key: "emailMaxLength",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return (this === null || this === void 0 ? void 0 : (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.email_maxlength) || 40;
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this5 = this;

      runInAction(function () {
        _this5._componentRef = _componentRef;
      });
    }
  }]);

  return EmailReceiptModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_emailId", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isEmailVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "emailId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emailId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isEmailVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isEmailVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emailMaxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emailMaxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype)), _class);
export { EmailReceiptModel as default };